import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';
import { Select } from 'formComponents/Select/Select';
import { KundeArtLabel } from 'utils/labels';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';

interface KundeArtProps {
    disabled?: boolean;
    value: string;
    addAll?: boolean;
    renderLabel?: 'label' | 'placeholder';
    onChange: (newValue: string) => void;
}

const allOption = { value: '__all__', label: 'Alle' };

export const KundeArt: React.FC<KundeArtProps> = ({
    value,
    disabled = false,
    renderLabel = 'label',
    addAll = false,
    onChange,
}) => {
    const options = React.useMemo(() => {
        const list: SelectOption[] = [];
        if (addAll) {
            list.push(allOption);
        }

        Object.keys(KundeArtLabel).forEach((key) => {
            list.push({
                value: key,
                label: KundeArtLabel[key],
            });
        });

        return list;
    }, [addAll]);

    const selectedOption = React.useMemo(() => {
        if (value === '__all__') {
            return allOption;
        }

        if (value) {
            return {
                value,
                label: KundeArtLabel[value] || value,
            };
        }

        return {
            value: '',
            label: '',
        };
    }, [value]);

    return (
        <>
            {renderLabel === 'label' && <Label>Art</Label>}
            <Select
                name="kundeArt"
                isDisabled={disabled}
                value={selectedOption}
                options={options}
                onChange={(option: ValueType<SelectOption, false>): void => {
                    onChange(option?.value || '');
                }}
                placeholder={renderLabel === 'placeholder' ? 'Art' : ''}
            />
        </>
    );
};
